import request from '@/utils/request'
import insureRequest from '@/utils/insureRequest'
import { ConstConfig } from '@/utils'

export function registReferee(data) {
  return request({
    url: ConstConfig.apiPath + '/RegistReferee.json',
    method: 'post',
    data
  })
}

export function registPlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/RegistPlayer.json',
    method: 'post',
    data
  })
}

export function registCoach(data) {
  return request({
    url: ConstConfig.apiPath + '/RegistCoach.json',
    method: 'post',
    data
  })
}

export function registOrganization(data) {
  return request({
    url: ConstConfig.apiPath + '/RegistOrganization.json',
    method: 'post',
    data
  })
}

export function getMyMembershipStatus(params) {
  return request({
    url: ConstConfig.apiPath + '/GetMyMembershipStatus.json',
    method: 'get',
    params
  })
}

export function updateMembershipStatus(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateMembershipStatus.json',
    method: 'post',
    data
  })
}

export function getAgreementById(id) {
  const params = {
    id: id
  }
  return request({
    url: ConstConfig.apiPath + '/AdminGetAgreementDetail.json',
    method: 'get',
    params
  })
}

export function getSchoolList(params) {
  params = params || {}
  params.pageSize = 9999
  return request({
    url: ConstConfig.apiPath + '/GetSchoolList.json',
    method: 'get',
    params
  })
}

export function getOrganizationList(params) {
  params = params || {}
  return request({
    url: ConstConfig.apiPath + '/GetOrganizationList.json',
    method: 'get',
    params
  })
}

export function getCoachList(params) {
  params = params || {}
  params.pageSize = 9999
  return request({
    url: ConstConfig.apiPath + '/GetCoachList.json',
    method: 'get',
    params
  })
}

export function getRegCoach() {
  return request({
    url: ConstConfig.apiPath + '/GetMyRegistCoach.json',
    method: 'get',
  })
}

export function getRegPlayer() {
  return request({
    url: ConstConfig.apiPath + '/GetMyRegistPlayer.json',
    method: 'get',
  })
}

export function getRegOrganization() {
  return request({
    url: ConstConfig.apiPath + '/GetMyRegistOrganization.json',
    method: 'get',
  })
}

export function getRegReferee(type) {
  const params = {
    inField: type
  }
  return request({
    url: ConstConfig.apiPath + '/GetMyRegistReferee.json',
    method: 'get',
    params
  })
}

export function getMyPlayer() {
  return request({
    url: ConstConfig.apiPath + '/GetMyPlayer.json',
    method: 'get'
  })
}

export function getMyCoach() {
  return request({
    url: ConstConfig.apiPath + '/GetMyCoach.json',
    method: 'get'
  })
}

export function getMyReferee() {
  return request({
    url: ConstConfig.apiPath + '/GetMyReferee.json',
    method: 'get'
  })
}

export function getMyOrganization() {
  return request({
    url: ConstConfig.apiPath + '/GetMyOrganization.json',
    method: 'get'
  })
}

export function updatePlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdatePlayer.json',
    method: 'post',
    data
  })
}

export function updateCoach(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateCoach.json',
    method: 'post',
    data
  })
}

export function updateReferee(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateReferee.json',
    method: 'post',
    data
  })
}

export function updateOrganization(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateOrganization.json',
    method: 'post',
    data
  })
}

export function getSourceList() {
  return ['通过协会微信公众号、微博、官网，渠道', '从别人那里听说的，渠道', '去冰场滑冰时看到有人打冰球', '其他渠道']
}

export function postInsureRequestI(data) {
  return insureRequest({
    url: '/bjhockey2019/',
    method: 'post',
    data
  })
}

export function createMembershipInsuranceOrder(params) {
  return request({
    url: ConstConfig.apiPath + '/CreateMembershipInsuranceOrder.json',
    method: 'get',
    params
  })
}

export function getInsuranceOrder(params) {
  return request({
    url: ConstConfig.apiPath + '/GetInsureOrder.json',
    method: 'get',
    params
  })
}

export function checkID(params) {
  return request({
    url: ConstConfig.apiPath + '/CheckID.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/info.js